module.exports = __webpack_public_path__ + "img/receipt2.2cd62183.png";